import { Link } from "react-router-dom";
import { AudioLines } from "lucide-react";

export const LogoMark = ({ className = "h-9 w-9", iconClass = "h-5 w-5", testid }) => (
  <span data-testid={testid} className={`bg-brand relative inline-flex shrink-0 items-center justify-center rounded-xl text-white shadow-[0_8px_20px_-8px_hsl(var(--primary)/0.7)] ${className}`}>
    <AudioLines className={iconClass} />
  </span>
);

export const Logo = ({ to = "/", compact = false }) => (
  <Link to={to} data-testid="logo-link" className="group inline-flex items-center gap-2.5">
    <span className="inline-flex transition-transform duration-300 group-hover:rotate-[-6deg]"><LogoMark /></span>
    {!compact && (
      <span className="font-display text-lg font-extrabold tracking-tight">
        NoteMyClass <span className="text-brand">AI</span>
      </span>
    )}
  </Link>
);
